import { CoreIcon } from '../core-icon';
import checkCircleSVG from '../../assets/icons/check-circle.svg';
import type { IconProps } from '../core-icon';

export const CheckCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={checkCircleSVG} {...props} />;
};
